import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'

import type { Client, ClientConfigResponse } from '@app/types'
import { logger } from '@app/utils/logger'
import { AxiosError, AxiosResponse } from 'axios'

export const fetchUserClients = async (): Promise<Client[]> => {
  try {
    const response: AxiosResponse<Client[]> = await apiClient.get(Endpoint.getAvailableClients, {
      headers: {
        'ui-client-name': localStorage.getItem('client_name') || 'null',
      },
    })
    return response.data
  } catch (err) {
    const axiosErr = err as AxiosError<{ message: string }>
    const msg =
      axiosErr.response?.data?.message || axiosErr.message || 'Failed to load user clients'
    throw new Error(msg)
  }
}

export async function fetchClientConfig(): Promise<ClientConfigResponse> {
  const response = await apiClient.get(Endpoint.getClientConfig, {
    headers: {
      'ui-client-name': localStorage.getItem('client_name') || 'null',
    },
  })
  return response.data
}

export const fetchUserInfo = async () => {
  try {
    const response = await apiClient.get(`/user`, {
      headers: {
        'ui-client-name': localStorage.getItem('client_name') || 'null',
      },
    })
    return response.data
  } catch (error) {
    logger.error('Error fetching user info:', error)
  }
}
